"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var PlayerState_1 = __importDefault(require("../constants/PlayerState"));

var FullUi_1 = __importDefault(require("./FullUi"));

var StartUiLive_1 = __importDefault(require("./StartUiLive"));

var StartUiVod_1 = __importDefault(require("./StartUiVod"));

var MutedUi_1 = __importDefault(require("./MutedUi"));

var DefaultUi =
/** @class */
function (_super) {
  __extends(DefaultUi, _super);

  function DefaultUi(props) {
    var _this = _super.call(this, props) || this;

    _this.onUnmute = function () {
      _this.setState({
        startMutedWasUnmuted: true
      });
    };

    _this.state = {
      startMutedWasUnmuted: false
    };
    return _this;
  }

  DefaultUi.prototype.shouldShowStartUi = function () {
    // If the playerState is STOPPED, LOADING or LOADED, it means that the video
    // has not yet been played.
    return this.props.splash && (this.props.playerState === PlayerState_1["default"].STOPPED || this.props.playerState === PlayerState_1["default"].LOADING || this.props.playerState === PlayerState_1["default"].LOADED || this.props.playerState === PlayerState_1["default"].ENDED && !this.props.loop);
  };

  DefaultUi.prototype.shouldShowLiveCountdown = function () {
    return this.props.streamInfo && this.props.streamInfo.liveStart && Object.keys(this.props.streamInfo.videoReferences).length === 0;
  };

  DefaultUi.prototype.render = function () {
    if (!this.props.streamInfo) {
      return null;
    }

    if (this.shouldShowLiveCountdown()) {
      return React.createElement(StartUiLive_1["default"], {
        streamInfo: this.props.streamInfo,
        poster: this.props.poster
      });
    } // When, for instance, browsing with an iPhone with iOS < 10 (with no support for playsinline),
    // this simplified UI with only a play/pause button will be used.


    if (this.shouldShowStartUi()) {
      return React.createElement(StartUiVod_1["default"], {
        controller: this.props.controller,
        playerState: this.props.playerState,
        streamInfo: this.props.streamInfo,
        loaderVisible: this.props.loaderVisible,
        duration: this.props.duration,
        setPlayQueued: this.props.setPlayQueued
      });
    }

    if (this.props.useNativeControls === true) {
      return null;
    }

    if (this.props.startMuted && !this.state.startMutedWasUnmuted) {
      return React.createElement(MutedUi_1["default"], {
        controller: this.props.controller,
        onUnmute: this.onUnmute
      });
    }

    return React.createElement(FullUi_1["default"], {
      controller: this.props.controller,
      streamInfo: this.props.streamInfo,
      playerState: this.props.playerState,
      position: this.props.position,
      duration: this.props.duration,
      volume: this.props.volume,
      muted: this.props.muted,
      getFullscreenElement: this.props.getFullscreenElement,
      autoPlay: this.props.autoPlay,
      uiPosition: this.props.uiPosition,
      loop: this.props.loop,
      setPlayQueued: this.props.setPlayQueued,
      isTouch: this.props.isTouch
    });
  };

  DefaultUi.contextTypes = {
    theme: PropTypes.object
  };
  DefaultUi.defaultProps = {
    splash: true
  };
  return DefaultUi;
}(React.Component);

exports["default"] = DefaultUi;